import React from "react";
import { useNavigate } from "react-router-dom";

import "./SupplierDashboard.css";

const SupplierVehicles = () => {
  const navigate = useNavigate();

  return (
    <div className="supplier-dashboard">

      <aside className="supplier-sidebar">

        <div className="supplier-sidebar-brand">
          <div className="supplier-brand-icon">
            🚌
          </div>

          <div>
            <strong>
              Fleet Management Pro
            </strong>

            <span>
              SUPPLIER PORTAL
            </span>
          </div>
        </div>

        <nav className="supplier-sidebar-nav">

          <button
            type="button"
            className="supplier-nav-item"
            onClick={() =>
              navigate("/supplier/dashboard")
            }
          >
            <span className="nav-icon">⌂</span>
            <span>Dashboard</span>
          </button>

          <button
            type="button"
            className="supplier-nav-item active"
          >
            <span className="nav-icon">▣</span>
            <span>My Vehicles</span>
          </button>

          <button
            type="button"
            className="supplier-nav-item"
            onClick={() =>
              navigate(
                "/supplier/vehicle-documents"
              )
            }
          >
            <span className="nav-icon">▤</span>
            <span>Vehicle Documents</span>
          </button>

          <button
            type="button"
            className="supplier-nav-item"
            onClick={() =>
              navigate(
                "/supplier/statements"
              )
            }
          >
            <span className="nav-icon">▥</span>
            <span>Statements</span>
          </button>

        </nav>
      </aside>

      <div className="supplier-main">

        <header className="supplier-topbar">

          <div className="supplier-topbar-left">
            <button
              type="button"
              className="supplier-menu-btn"
              onClick={() =>
                navigate(
                  "/supplier/dashboard"
                )
              }
            >
              ←
            </button>

            <div className="mobile-brand">
              <strong>
                Fleet Management Pro
              </strong>

              <span>
                SUPPLIER PORTAL
              </span>
            </div>
          </div>

        </header>

        <main className="supplier-dashboard-content">

          <section className="supplier-recent-card">

            <div className="supplier-section-header">

              <div className="section-title-wrap">

                <div className="section-icon">
                  ▣
                </div>

                <div>
                  <h2>
                    My Vehicles
                  </h2>

                  <p>
                    View your assigned vehicles.
                  </p>
                </div>

              </div>

            </div>

            <div className="supplier-empty-state">

              <div className="supplier-empty-icon">
                ▣
              </div>

              <h3>
                My Vehicles
              </h3>

              <p>
                Your assigned vehicles will
                appear here.
              </p>

            </div>

          </section>

        </main>

      </div>

    </div>
  );
};

export default SupplierVehicles;